let http = '://apis.jinglunjiaoyu.com';

http = 'https://apis.jinglunjiaoyu.com';
//开发模式
if (process.env.NODE_ENV == 'development') {     
    // http = '://hainanpeixun.zhilongsoft.com'
    // http = 'https' + http
}   
else if (process.env.NODE_ENV == 'debug') {    
} 
//正式模式
// else if (process.env.NODE_ENV == 'production') {    
//     if(~window.location.href.indexOf('https')){
//         http = 'https' + http
//     } else{
//         http = 'http' + http
//     }
// }

export default {
	openMail: false, //打开邮寄服务
	openNew: true,//打开新功能
	isDebug: process.env.NODE_ENV != 'production',
	baseTitle:'海口京伦教育培训中心有限公司职业培训网',
    http,
    LOGIN_BG_CLASS:['/login', '/reg', '/reg2','/reg3','/reg4','forget'], //登录注册背景图,
    USER_TYPE:{
      COLLEGE:1, //学员
      ENTER:2,  //企业
    },
    RESOK: 1, //接口返回成功
    ISTURE:1,
    OVERTIME: 10, //登录超时
    timeLoad: 1500, //等待时间
    SHOW: '0', //是否隐藏,显示
    HIDE: '1', //是否隐藏,隐藏
    uploadImg: http + '/pubdata/uploadimg', //上传图片
    upPrefix:http + '/uploads/',
    verCode(){
        return {
            text: '发送验证码',
            code: '',
            isDownIng: false,
            i: 60,
            t: null,
			sendLoading:false,
        }
    },
    //分页
    pages(){
        const pageSizes = ["10", "20", "50"];
        return {
            total: 0,
            currentPage: 1,
            pageSize: parseInt(pageSizes[0]),
            pageSizes,
        }
    },
    IS_EXAM:1, //是否考试
    COURSE_TYPE_FACE:1, //面授课程
    COURSE_TYPE_FACE_NAME: '面授',
    COURSE_TYPE_LINE:2, //线上课程
    COURSE_TYPE_LINE_NAME: '网授',
    EXAM_TYPE_UP:1, //网授课程 1线上考试 
    EXAM_TYPE_DOWN:2,//网授课程 2线下考试
    PASS_ADOPT:2,//考试通过
    PASS_NO:3,//考试不合格
    SUBJECT_TYPE:1, //刷题
    REVIEW_TYPE:2, //复习题
    PAY_LINE:1,//线下报名
	NOT_DEUCATION:0,//旧用户学历
    REG_REPEAT_TYPE:{
        NAMES:1,
        EMAIL:2,
        CODEID:3,
        MOBILE:4,
    },
    //分类
    CAT_TYPE:{
        CAT_TOP:32,//头条
        CAT_BAN:72,//轮播
        CAT_AD_MID:12,//中间
        CAT_AD_BOT:16,//底部
        CAT_AD_END:33,//最底部
        CAT_FAST:62,//快捷入口
        CAT_COMPANY:63,//企业展台
        CAT_COURSE:25,//课程
        CAT_COURSE_FREE:32,//免费课程
        CAT_TRAIN:45,//培训信息
        CAT_REG:40,//注册信息
        CAT_EXAM:7,//考试考务
        CAT_BADGE:33,//证章领取
        CAT_RECRUIT:58,//企业招聘
        CAT_JOB:59,//人才求职
        CAT_PARTY: 5,//党建之窗
        CAT_POLICY: 4,//政策法规
        CAT_GUIDE: 3,//办事指南
        CAT_FAQ:73, //常见问题
        CAT_CENTER:2,//中心机构
        CAT_NEWS:6,//动态信息
        CAT_PRACTICE:8,//执业注册
        CAT_TRAIN_NEWS:9,//培训教育
        CAT_RECRUIT_MAIN:11,//人才交流
        CAT_DOWNLOAD:12,//下载中心
        CAT_REGART:4,//注册协议
        CAT_EDUCATION:17,//学历
    },
    RECRUIT_TYPE_ENTER:2,//招聘企业
    RECRUIT_TYPE_USER:1,//招聘求职
    INVOICE_TYPE:{
        EMAIL:1, //邮箱
        PAPER:2,//纸质
        E_USER:1, //电子发票个人
        E_COMPANY:2, //电子发票公司
        P_COMPANY:3,//纸质发票公司
    },
    USER_BANID:37,//用户中心轮播图
    COMPANY_BANID:38,//企业中心轮播图
}
